var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_348_47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13441",
    d: "M0 0V16H16V0H0ZM3.92383 3.14551C4.55756 3.15264 5.18183 3.58984 5.20899 4.34668C5.22253 5.01968 4.63604 5.53229 3.90723 5.54785H3.88965C3.26223 5.54061 2.64949 5.09244 2.62109 4.34668C2.63004 3.68117 3.18945 3.16129 3.92383 3.14551ZM10.7227 6.3252C11.4194 6.32952 12.0769 6.53621 12.6172 7.08693C13.1786 7.71307 13.3588 8.5764 13.3789 9.45411V13.4463H11.0781V9.72559C11.073 9.02823 10.8341 8.18056 9.91113 8.15235C9.37019 8.15811 8.98873 8.47244 8.72753 8.99805C8.65623 9.16723 8.64596 9.36169 8.64257 9.55567V13.4463H6.34277C6.35157 11.5013 6.36367 9.55639 6.35937 7.61133C6.35937 7.05883 6.35405 6.6868 6.34277 6.49512H8.64257V7.47559C8.83779 7.19795 9.05429 6.93464 9.34471 6.72265C9.73864 6.44152 10.2119 6.33375 10.7227 6.3252ZM2.75684 6.49512H5.05664V13.4463H2.75684V6.49512Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.a7838df970a4e3b223ff972f2842a0e5.svg";
export { ForwardRef as ReactComponent };